exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".conteiner-image[data-v-438e5b00]{width:96px;height:96px;display:flex;justify-content:center;align-items:center;margin-bottom:10px}.cover[data-v-438e5b00]{border-radius:10%;object-fit:fill;object-position:center;width:100%;height:100%}.conteiner-pdf[data-v-438e5b00]{width:96px;height:96px;display:flex;justify-content:center;align-items:center;margin-bottom:10px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-438e5b00","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/inventario_Componentes/shared/ModalDocumentos.vue
// module id = 2211
// module chunks = 0